/**
 * PageHelp — Хуудасны ТУСЛАМЖ товч.
 *
 *   <PageHelp topic="risk/assessment" />
 *   <PageHelp />                        // ← түлхүүрийг ЗАМААС нь өөрөө авна
 *
 * ⚠ ТҮЛХҮҮРГҮЙ хэлбэр яагаад хэрэгтэй вэ:
 *   Зарим толгой (header) НЭГ файл боловч ХЭД ХЭДЭН замд ашиглагдана —
 *   ж: `high_risk/list/header.js` нь /highrisk/list ба /highrisk/approve
 *   хоёуланд. Хатуу түлхүүр бичвэл хоёр өөр хуудсанд ИЖИЛ заавар гарах
 *   тул замаас нь уншина.
 *
 * Асуултын тэмдэг дээр дархад тухайн хуудастай ажиллах зааварчилгаа
 * гарч ирнэ. Агуулга нь `helpContent.js`-д — код дотор тарж бичихгүй.
 *
 * ⚠ ЗААВАР ОЛДОХГҮЙ бол товч ОГТ ГАРАХГҮЙ. Хоосон цонх нээгдэх нь
 *   зааваргүй байснаас дор — хэрэглэгч дарж үзээд юу ч олохгүй бол
 *   тусламжийн системд итгэхээ болино.
 *
 * Байрлал: хуудасны толгой эсвэл хяналтын (KPI) хэсгийн баруун тал.
 */
import React, { useEffect, useState } from "react";
import { Modal, Tooltip } from "antd";
import { useLocation } from "react-router-dom";
import { helpFor } from "./helpContent";
import { fetchHelp } from "src/api/help";
import HelpBody from "./HelpBody";

export default function PageHelp({
  topic: topicProp,
  // Толгой нь тод дэвсгэртэй үед цагаан, цайвар дэвсгэрт саарал
  light = false,
  size = 16,
  style,
}) {
  const [open, setOpen] = useState(false);
  /* Видео заавартай хуудсыг ИЛ тэмдэглэнэ — асуултын тэмдэг дотор юу
     байгааг хэрэглэгч урьдчилан мэдэхгүй тул дардаггүй (2026-09-30). */
  const hasVideo = (h) => !!(h && h.video_url);
  const { pathname } = useLocation();
  // Замын `/`-г тайрч түлхүүр болгоно: "/highrisk/list" → "highrisk/list".
  // `helpFor` нь дэд замыг дээшээ унагадаг тул "/risk/assessment/42" дээр
  // "risk/assessment"-ийн заавар гарна.
  const topic = topicProp || String(pathname || "").replace(/^\/+/, "");
  // ⚠ ХОЁР ЭХ СУРВАЛЖ: бааз нь ЭЗЭН (ХАБЭА хэлтэс өөрөө засна), код нь
  //   НӨӨЦ. Баазад тухайн түлхүүр байхгүй эсвэл хүснэгт бэлэн биш үед
  //   кодын анхдагч агуулга гарна — тусламж хэзээ ч алга болохгүй.
  const [remote, setRemote] = useState(null);
  const fallback = helpFor(topic);

  useEffect(() => {
    // ⚠ Түлхүүр солигдоход хуучин агуулгыг ЦЭВЭРЛЭНЭ. Эс бөгөөс замаас
    //   түлхүүрээ авдаг тохиолдолд өмнөх хуудасны заавар шинэ хуудсанд
    //   агшин зуур харагдана.
    setRemote(null);
    if (!topic) return;
    let alive = true;
    fetchHelp(topic)
      .then((d) => alive && d?.item && setRemote(d.item))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [topic]);

  /* ⚠ БААЗ нь кодыг ДАРЖ БИЧИХГҮЙ, НЭГТГЭНЭ (2026-09-29).
     Өмнө нь `remote || fallback` байсан: баазад сэдэв нэмэгдмэгц кодын
     агуулга БҮХЭЛДЭЭ хаягддаг. Улмаар код дээр байгаа хэсгүүд (жишээ:
     ТҮВШИНГИЙН заавар `roles`, журмын эх сурвалж `rule`) ХАБЭА хэлтэс
     баазаас гарчгийг нь засмагц чимээгүй алга болно.
     Нэгтгэхдээ баазын ХООСОН утга кодыг дарж болохгүй — админ UI нь
     бөглөөгүй талбарыг `''` эсвэл `[]` гэж буцаадаг. */
  const help = React.useMemo(() => {
    if (!remote) return fallback;
    if (!fallback) return remote;
    const out = { ...fallback };
    Object.entries(remote).forEach(([k, v]) => {
      const empty =
        v === null ||
        v === undefined ||
        (typeof v === "string" && !v.trim()) ||
        (Array.isArray(v) && v.length === 0);
      if (!empty) out[k] = v;
    });
    return out;
  }, [remote, fallback]);

  // Заавар бичигдээгүй хуудсанд товч харагдахгүй
  if (!help) return null;

  const color = light ? "rgba(255,255,255,0.85)" : "#8A94A6";

  return (
    <>
      <Tooltip
        title={
          hasVideo(help)
            ? "Энэ хуудастай хэрхэн ажиллах вэ? — ВИДЕО заавартай"
            : "Энэ хуудастай хэрхэн ажиллах вэ?"
        }
      >
        <button
          type="button"
          aria-label="Тусламж"
          onClick={() => setOpen(true)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: size + 8,
            height: size + 8,
            padding: 0,
            border: "none",
            background: "transparent",
            color,
            cursor: "pointer",
            fontSize: size,
            lineHeight: 1,
            ...style,
          }}
        >
          <i className="fas fa-question-circle" />
          {/* ⚠ Видеотой бол ЖИЖИГ ногоон цэг — асуултын тэмдэг дотор юу
              байгааг мэдэхгүй тул хэрэглэгч дардаггүй байв. Цэг нь
              «энд үзэх зүйл бий» гэдгийг хэлнэ. */}
          {hasVideo(help) ? (
            <span
              style={{
                position: "absolute",
                marginLeft: size - 2,
                marginTop: -(size - 2),
                width: 7,
                height: 7,
                borderRadius: 4,
                background: "#0F6E56",
                border: "1.5px solid #fff",
              }}
            />
          ) : null}
        </button>
      </Tooltip>

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        /* ⚠ ЗААВАЛ (2026-10-14, хэрэглэгчийн гомдол): «цонхны чагтаар
           хаасан үед бичлэг тоглож үлдэж байсан». antd нь хаахад
           доторхыг УСТГАДАГГҮЙ, зөвхөн НУУДАГ — `<video autoPlay>`
           тоглосоор, дуу нь гарсаар байв. `destroyOnClose` нь
           `HelpBody`-г unmount болгоно (нэмэлт даатгал: `HelpBody`
           өөрөө ч unmount дээр `pause()` хийдэг).
           ⚠ Нэмэлт ашиг: дахин нээхэд видео автоматаар тоглохгүй
             (`showVideo` нь шинээр `false` болно). */
        destroyOnClose
        /* ⚠ ӨРГӨН ЦОНХ (2026-09-29): заавар нь ДЭЛГЭЦИЙН ЗУРАГТАЙ болсон.
           620px дээр бүтэн хуудасны зураг жижгэрч, доторх бичээс
           уншигдахгүй байв — хэрэглэгч дарж томруулах шаардлагатай болж,
           «заавар ойлгомжгүй» гэсэн мэдрэмж төрүүлнэ.
           ⚠ Хатуу px БИШ: нарийн дэлгэц (утас, 1366px зөөврийн) дээр
             цонх дэлгэцээс халих ёсгүй тул `min()`-ээр хумина. */
        width="min(1100px, 94vw)"
        style={{ top: 24 }}
        bodyStyle={{ maxHeight: "78vh", overflowY: "auto" }}
        title={
          <span>
            <i
              className="fas fa-question-circle"
              style={{ marginRight: 8, color: "#0EA5E9" }}
            />
            {help.title}
          </span>
        }
      >
        <HelpBody help={help} />
      </Modal>
    </>
  );
}
